import { Form, Input, ModalProps, FormProps, Modal, InputNumber, Select, useSelect, message } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { findProjectFieldName } from 'gql/query'
import { IGrade, ISubject } from 'interfaces'

type EditSubThemeProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const EditSubTheme: React.FC<EditSubThemeProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()
  const { selectProps: subjectSelectProps } = useSelect<ISubject>({
    resource: 'themes',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    if (values && values?.name?.trim() && values.theme_id) {
      values.name = values?.name?.trim()
      const isNameStillSame = values?.name === formProps?.initialValues?.name
      if (!isNameStillSame) {
        const isNameRepeated: any = await findProjectFieldName(values.name, 'name', 'sub_themes')
        if (isNameRepeated && isNameRepeated?.sub_themes?.length > 0) {
          message.error('Sub-theme name is already present... please make sure Sub themes are unique')
          return false
        }
      }
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          updated_by: user?.id,
        })
      )
    } else {
      message.error('Expected values are missing...')
    }
  }
  return (
    <Modal {...modalProps} title="Edit Sub Theme">
      <Form
        {...formProps}
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              createUserHistory('sub_themes', 'edit', response?.data?.id, user?.id, userRole)
            }
          })

          return response
        }}
      >
        <Form.Item
          label="Sub Theme Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Theme" name="theme_id" rules={[{ required: true }]}>
          <Select {...subjectSelectProps} />
        </Form.Item>
        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
